const PropTypes = require('prop-types');
// require('./brokerStocksSellStep1.scss');

// @vendors
const React = require('react');
const _ = require('lodash');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @constants
const {
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED
} = require('constants/index');

const BrokerOrderTypeCheckbox = props => {
    const { value, onChange, productCurrency } = props;
    const currency = !_.isEmpty(productCurrency) ? `(${productCurrency})` : '';
    return (
        <RadioButtonGroup
            selectedValue={value}
            onChange={onChange}
            name="stocksSellOrderType"
            idPrefix="stocksSellOrderType"
        >
            <RadioButton
                label={formatText('broker-stocksSellOrderTypeOption1')}
                value={BROKER_ORDER_TYPE_TO_MARKET}
                className="stocks-sell-step1__radio-button"
            />
            <RadioButton
                label={formatText('broker-stocksSellOrderTypeOption2')}
                value={BROKER_ORDER_TYPE_FOR_THE_BEST}
                className="stocks-sell-step1__radio-button"
            />       
            <RadioButton
                label={formatText('broker-stocksSellOrderTypeOption3Step1', [currency])}
                value={BROKER_ORDER_TYPE_LIMITED}
                className="stocks-sell-step1__radio-button"
            />
        </RadioButtonGroup>
    );
};

BrokerOrderTypeCheckbox.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    productCurrency: PropTypes.string
};

module.exports = BrokerOrderTypeCheckbox;